import Chip from "@mui/material/Chip";
import { SxProps, Theme } from "@mui/material/styles";

// Chip "Inativa" ao lado do nome da empresa (spec §4.2, mockup G1). Único para Antecipações e Conferência.
export default function InactiveChip({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Chip
      size="small"
      label="Inativa"
      data-testid="inactive-chip"
      sx={[{ height: 18, fontSize: 10.5, bgcolor: "#f1f2f4", color: "#6b7280", flexShrink: 0 }, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );
}
